import React from 'react';
import PropTypes from 'prop-types';
import { FloatingLabelInput as Input, SelectableBlock } from '../../../Elements';
import styles from './TermsBuilder.scss';
import Option from './Option';

const ClientResponsibilities = ({
  contractVariables,
  textFieldChange,
  yesNoChange
}) =>
  <div>
    <h3>
      How many weeks in advance of the event will the client need to submit
      their requests and planning materials?
    </h3>
    <Input
      className={styles.inlineField}
      name='planningDeadline'
      type='number'
      inline
      required
      validationError='Required'
      value={contractVariables.planningDeadline}
      onChange={textFieldChange}
    />
    <div className={styles.inlineFieldLabel}>weeks</div>
    <h3>Do you require the client to provide you a meal?</h3>
    <Option>
      <SelectableBlock
        name='mealRequired'
        content='Yes'
        value='yes'
        radio
        checked={contractVariables.mealRequired}
        onChange={yesNoChange}
      />
    </Option>
    <Option>
      <SelectableBlock
        name='mealRequired'
        content='No'
        value='no'
        radio
        checked={!contractVariables.mealRequired}
        onChange={yesNoChange}
      />
    </Option>
  </div>;

ClientResponsibilities.propTypes = {
  contractVariables: PropTypes.object.isRequired,
  textFieldChange: PropTypes.func.isRequired,
  yesNoChange: PropTypes.func.isRequired
};

export default ClientResponsibilities;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/TermsBuilder/Client.js